<template>
  <div
    class="age-modal-overlay"
    :class="{ 'fade-in': !isClose, 'fade-out': isClose }"
    v-if="!isVerified"
  >
    <div
      class="age-modal"
      :class="{ 'slide-up': !isClose, 'slide-down': isClose }"
    >
      <div class="modal-header">
        <h2 class="modal-title">Age Verification Required</h2>
      </div>
      <div class="modal-body">
        <!-- <div class="warning-icon">⚠️</div> -->
        <p class="main-text">
          The Ear's content is intended for adults 18 years of age or older
        </p>
        <p class="sub-text">
          Please confirm the legal age requirement to continue.
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn confirm-btn" @click="confirmAge">
          <span>Yes, I'm 18 or older</span>
        </button>
        <button class="btn reject-btn" @click="reload">
          <span>No, take me back</span>
        </button>
      </div>
    </div>
  </div>
  <CookieToast v-if="isVerified" />
</template>

<script>
import CookieToast from "./CookieToast.vue";

export default {
  name: "AgePopup",
  components: {
    CookieToast,
  },
  data() {
    return {
      isVerified: localStorage.getItem("age_validity") === "true" || false,
      isClose: false,
    };
  },
  methods: {
    confirmAge() {
      this.isClose = true;
      setTimeout(() => {
        this.isVerified = true;
        localStorage.setItem("age_validity", "true");
      }, 500);
    },
    reload() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.reload();
      }
    },
  },
  created() {
    if (!this.isVerified) {
      document.body.style.overflow = "hidden";
    }
  },
  watch: {
    isVerified(newValue) {
      document.body.style.overflow = newValue ? "" : "hidden";
    },
  },
};
</script>

<style lang="scss" scoped>
.age-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.age-modal-overlay.fade-in {
  opacity: 1;
}

.age-modal-overlay.fade-out {
  opacity: 0;
}

.age-modal {
  background: #0d1117;
  border-radius: 20px;
  width: 90%;
  max-width: 460px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transform: translateY(50px);
  opacity: 0;
  overflow: hidden;
}

.age-modal.slide-up {
  animation: slideUp 0.5s ease forwards;
}

.age-modal.slide-down {
  animation: slideDown 0.5s ease forwards;
}

.modal-header {
  padding: 24px;
  background: #0d1117;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  width: 100%;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.modal-body {
  padding: 10px 24px;
  text-align: center;
  background: #0d1117;
}

.warning-icon {
  font-size: 48px;
  margin-bottom: 20px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.main-text {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 16px;
  line-height: 1.5;
  font-weight: 600;
}

.sub-text {
  font-size: 14px;
  color: #b8c2cc;
  margin: 0;
  line-height: 1.5;
}

.modal-footer {
  padding: 24px;
  display: flex;
  gap: 10px;
  background: #0d1117;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 650px) {
    zoom: 85%;
  }
}

.btn {
  border: none;
  border-radius: 30px;
  padding: 16px 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  position: relative;
  overflow: hidden;
  flex: 1;
}

.btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0)
  );
  transition: all 0.3s ease;
}

.confirm-btn {
  background: linear-gradient(145deg, #4caf50, #388e3c);
  color: white;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.reject-btn {
  background: linear-gradient(145deg, #f44336, #d32f2f);
  color: white;
  box-shadow: 0 4px 15px rgba(244, 67, 54, 0.3);
}

.reject-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(244, 67, 54, 0.4);
}

@keyframes slideUp {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
  }
}

@media (max-width: 480px) {
  .modal-title {
    font-size: 20px;
  }

  .main-text {
    font-size: 16px;
  }

  .sub-text {
    font-size: 14px;
  }

  .btn {
    padding: 14px 28px;
    font-size: 15px;
  }
}
</style>
